import { ServiceIdentifier } from '../service-locator';
import { InteractivityService } from './interfaces';

export * from './interfaces';

export const INTERACTIVITY_SERVICE = ServiceIdentifier.get<InteractivityService>('InteractivityService');
